var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warn-msg" },
    [
      _c(
        "el-popover",
        { ref: "popover", attrs: { placement: "bottom", trigger: "hover" } },
        [
          _c("div", { staticClass: "flex-col" }, [
            _c("a", { on: { click: _vm.enterWarnList } }, [_vm._v("查看")]),
            _vm._v(" "),
            _c("a", { on: { click: _vm.readAll } }, [_vm._v("全部已读")]),
            _vm._v(" "),
            _c("a", { on: { click: _vm.toggleSpeech } }, [
              _vm._v(_vm._s(_vm.isSpeechPaused ? "开启播报" : "关闭播报")),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { slot: "reference" }, slot: "reference" },
            [
              _vm.alarmCount === 0
                ? _c("i", {
                    staticClass: "el-icon-message-solid",
                    attrs: { title: "告警信息" },
                  })
                : _c(
                    "el-badge",
                    { attrs: { value: _vm.alarmCount, max: 99 } },
                    [
                      _c("i", {
                        staticClass: "el-icon-message-solid",
                        attrs: { title: "告警信息" },
                      }),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }